import { connect } from '@atlassian/jira-react-redux';
import { maybeRuleSetIds } from '../../../state/selectors/rulesets';
import type { State } from '../../../state/types';
import RuleListItem from './rule';
import RuleList from './view';

const mapStateToProps = (state: State) => ({
	ListItemComponent: RuleListItem,
	ruleIds: maybeRuleSetIds(state).orSome([]),
});

export default connect(mapStateToProps, {})(RuleList);
